
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oranges/home",
      function () {
        return require("private-next-pages/oranges/home/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oranges/home"])
      });
    }
  